import { Suspense } from 'react';
import { Outlet } from 'react-router-dom';
import { AppShell } from '@app/layout/AppShell';

export default function AppFrame() {
  return (
    <AppShell>
      <Suspense fallback={<div className="route-loading">Loading module...</div>}>
        <Outlet />
      </Suspense>
    </AppShell>
  );
}
